import { getMember } from '@xo-union/store-membership-redux';
import store from '../utilities/store';

store.dispatch(getMember());
